import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/SonHomePage.jsx";
import Login from "./pages/Login.jsx";
import Dashboard from "./pages/Dashboard.jsx";
import Cadastro from "./pages/Cadastro.jsx";
import RecuperarSenha from "./pages/RecuperarSenha.jsx";
import ShowcaseApp from './pages/ShowcaseApp.jsx';
import NotFound from './pages/NotFound.jsx';
import PrivateRoute from './design-system/components/private-route/PrivateRoute.jsx';
import { Layout } from "./design-system/layouts/Layout.jsx";
import Config from "./pages/Config.jsx";
import Contatos from "./pages/Contatos.jsx";
import Projetos from "./pages/Projetos.jsx";
import Marketing from "./pages/Marketing.jsx";
import Universidade from "./pages/Universidade.jsx";
import Vendas from "./pages/Vendas.jsx";
import Financeiro from "./pages/Financeiro.jsx";
import Documentos from "./pages/Documentos.jsx";
import Atividades from "./pages/Atividades.jsx";
import Agenda from "./pages/Agenda.jsx";
import CRM from "./pages/CRM.jsx";
import IA from "./pages/Ia.jsx";
import Comunidades from "./pages/Comunidades.jsx";
import Admin from "./pages/Admin.jsx";
import PrivateAdmin from "./design-system/components/admin/PrivateAdmin.jsx";
import EmailEnviado from "./pages/EmailEnviado.jsx";
import NovaSenha from "./pages/NovaSenha.jsx";

function App() {
  return (
    <BrowserRouter>

      <Routes>

        {/* Home pública do SaaS */}
        <Route
          path="/"
          element={<Home />}
        />

        {/* Login */}

        <Route
          path="/login"
          element={<Login />}
        />

        {/* Cadastro*/}

        <Route
          path="/cadastro"
          element={<Cadastro />}
        />

        {/* Recuperar Senha*/}

        <Route
          path="/recuperarsenha"
          element={<RecuperarSenha />}
        />

        {/* Área logada */}


        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <Layout>
                <Admin />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/configuracoes"
          element={
            <PrivateRoute>
              <Layout>
                <Config />
              </Layout>
            </PrivateRoute>
          }
        />


        <Route
          path="/contatos"
          element={
            <PrivateRoute>
              <Layout>
                <Contatos />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/projetos"
          element={
            <PrivateRoute>
              <Layout>
                <Projetos />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/financeiro"
          element={
            <PrivateRoute>
              <Layout>
                <Financeiro />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/agenda"
          element={
            <PrivateRoute>
              <Layout>
                <Agenda />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/marketing"
          element={
            <PrivateRoute>
              <Layout>
                <Marketing />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/atividades"
          element={
            <PrivateRoute>
              <Layout>
                <Atividades />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/ia"
          element={
            <PrivateRoute>
              <Layout>
                <IA />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/Comunidades"
          element={
            <PrivateRoute>
              <Layout>
                <Comunidades />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/documentos"
          element={
            <PrivateRoute>
              <Layout>
                <Documentos />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/universidade"
          element={
            <PrivateRoute>
              <Layout>
                <Universidade />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/crm"
          element={
            <PrivateRoute>
              <Layout>
                <CRM />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/email-enviado"
          element={<EmailEnviado />}
        />
        {/* Área Demonstração */}

        <Route
          path="/showcaseApp"
          element={<ShowcaseApp />}

        />
        {/* Área Demonstração */}
        <Route
          path="*"
          element={<NotFound />}

        />

        <Route
          path="/nova-senha/:token"
          element={<NovaSenha />}
        />

      </Routes>

    </BrowserRouter>
  );
}

export default App;